import { removeColor } from '../editorUtilityFunctions/listUtilityFunctions';

export const commonListAttributes = {
    style: {
        default: '',
        parseHTML: (el: HTMLElement) => el.style.cssText || '',
        renderHTML: (attr: any) => ({
            style: `style: ${attr.style};`,
        }),
    },
    fontSize: {
        default: null,
        parseHTML: (element: HTMLElement) => {
            const style = element.getAttribute('style') || "";
            const regex = /font-size:\s*([^;]+)/i;
            const match = regex.exec(style);
            return match ? match[1] : null;
        },
        renderHTML: (attributes: any) => {
            if (!attributes.fontSize) return {};
            return { style: `font-size: ${attributes.fontSize};` };
        },
    },
};

export const createToggleListCommand = (listTypeName: 'bulletList' | 'orderedList') => {
    return (listStyleType: string) => (editor: any) => {
        const { state, chain } = editor;
        const elementAttributes = state.selection.$to.node()?.attrs || {};
        const marks = state.storedMarks || state.selection.$from.marks();
        const textStyleMark = marks?.find((m: any) => m.type.name === 'textStyle');

        const attributes = textStyleMark?.attrs?.color
            ? { style: `color: ${textStyleMark.attrs.color}; ${removeColor(elementAttributes.style || '')} ` }
            : { style: elementAttributes.style || '' };

        return chain()
            .toggleList(listTypeName, 'listItem')
            .updateAttributes(listTypeName, { listStyleType, style: removeColor(elementAttributes.style || '') })
            .updateAttributes('listItem', { ...attributes })
            .run();
    };
};
